import Vue from "vue";

Vue.component("coverage-search-results", {
	props: ["searchResults", "searchParameterSearchTerm", "searchParameterAnnexNumbers", "homePartyId"],
	data() {
		return {
			rankTooltip: window.labels.rankTooltip,
			showClassificationFormModal: false,
			partyId: 0,
			partyName: null,
			classificationLoading: false,
			classificationSystems: [],
			procurementClassificationSystems: [
				{
					name: window.labels.coverageSearchResultHsAllEntities,
					classificationSystems: [
						{ id: 1, code: 'HS5', name: window.labels.coverageSearchResultHs },
					]
				},
				{
					name: window.labels.coverageSearchResultHsDefense,
					classificationSystems: [
						{ id: 2, code: 'FSC', name: window.labels.coverageSearchResultFsc },
						{ id: 3, code: 'CN', name: window.labels.coverageSearchResultCn },
						{ id: 4, code: 'HSDEF', name: window.labels.coverageSearchResultHs },
						{ id: 5, code: 'CC0', name: window.labels.coverageSearchResultCccn }
					]
				},
				{
					name: window.labels.services,
					classificationSystems: [
						{ id: 6, code: 'W120', name: window.labels.coverageSearchResultW120 },
						{ id: 7, code: 'CPCProv', name: window.labels.coverageSearchResultCpcProv }
					]
				}
			]
		};
	},	
	template: `
		<div>
			<div v-for="(party, partyIndex) in searchResults" :key="partyIndex" class="columns">
				<div v-if="party.party1" class="column is-6">
					<b-collapse
						class="card"
						animation="slide"
						:open="false">
						<template #trigger="props">
							<div class="card-header pt-1 pb-1" role="button">
								<p class="card-header-title">{{ party.party1.name }}</p>
								<template v-if="party.party1.rank">
									<b-tooltip :label="rankTooltip" multilined class="party-rank-icon">
										<i data-toggle="tooltip" title="" :class="'fa fa-flag ' + party.party1.rankClass"></i>
									</b-tooltip>
								</template>
							</div>
						</template>
						<div class="card-content">
							<p class="party-content-language mb-0" v-if="party.party1.contentLanguage">
								{{ party.party1.contentLanguage }}</p>
							<party-annexes :party-id.sync="party.party1.id" :search-parameter-search-term.sync="searchParameterSearchTerm" :search-parameter-annex-numbers="searchParameterAnnexNumbers" :home-party-id="homePartyId"></party-annexes>
						</div>				
					</b-collapse>
				</div>
				<div v-if="party.party2" class="column is-6">
					<b-collapse
						class="card"
						animation="slide"
						:open="false">
						<template #trigger="props">
							<div class="card-header pt-1 pb-1" role="button">
								<p class="card-header-title">{{ party.party2.name }}</p>
								<template v-if="party.party2.rank">
									<b-tooltip :label="rankTooltip" multilined class="party-rank-icon">
										<i data-toggle="tooltip" title="" :class="'fa fa-flag ' + party.party1.rankClass"></i>
									</b-tooltip>
								</template>
							</div>
						</template>
						<div class="card-content">
							<p class="party-content-language mb-0" v-if="party.party2.contentLanguage">
								{{ party.party2.contentLanguage }}</p>
							<party-annexes :party-id.sync="party.party2.id" :search-parameter-search-term.sync="searchParameterSearchTerm" :search-parameter-annex-numbers="searchParameterAnnexNumbers" :home-party-id="homePartyId"></party-annexes>
						</div>
					</b-collapse>					
				</div>
			</div>			
		</div>
	`
});